const actionTypes = {
  FETCH_BANNERS_INFO: 'FETCH_BANNERS_INFO'
};

export default actionTypes;
